import { gql } from "@apollo/client";

const CHANGE_PASSWORD = gql`
mutation ChangePasswordMutation($id: ID!, $password: String!) {
  changePassword(id: $id, password: $password)
}
`;

export default CHANGE_PASSWORD;